import axios from '../axios.js';
import store from '../store/store';
import KeycloakService from './KeycloakService'

function getHeaders() {
    return {
        Authorization: 'Bearer ' + store.getters.getAccessToken
    }
}

export default {
    async getUserProfile() {
        return await this.httpGetRequest('/user');
    },
    async getReferrers(uuid) {
        return await this.httpGetRequest(`/user/${uuid}/referrals`);
    },
    async getTransactions() {
        return await this.httpGetRequest('/transaction/all');
    },
    async getUserBalance() {
        return await this.httpGetRequest('/user/statistics');
    },
    async getMembershipInfo() {
        return await this.httpGetRequest('/membership/valid');
    },
    async getUsersReferrer() {
        return await this.httpGetRequest('/user/referrer');
    },
    async getMinWithdraw() {
        return await this.httpGetRequest('/transaction/min_withdraw');
    },
    async getUserBinary() {
        return await this.httpGetRequest('/user/binary');
    },
    async getTreeConfig() {
        return await this.httpGetRequest('/config');
    },
    async changeConfig(configId) {
        return await this.httpPostRequest('/config', {configId});
    },
    async getAllConfigs() {
        return await this.httpGetRequest('/config/all');
    },
    async requestWithdrawal(amount) {
        return await this.httpPostRequest('/request/withdraw', {amount});
    },
    async requestPending() {
        return await this.httpGetRequest('/request/pending');
    },

    //Admin requests
    async getAllTransactions() {
        return await this.httpGetRequest('/admin/transaction/all');
    },
    async getAllUsers() {
        return await this.httpGetRequest('/admin/user/all');
    },
    async getTransactionStatistics() {
        return await this.httpGetRequest('/admin/transaction/statistics');
    },
    async requestPendingAdmin() {
        return await this.httpGetRequest('/admin/request/pending');
    },
    async resolveRequest(uuid) {
        return await this.httpPostRequest(`/admin/request/${uuid}/resolve`, {});
    },
    async getUsersReferrals(uuid) {
        return await this.httpGetRequest(`/admin/user/${uuid}/referrals`);
    },
    async getUsersStatistics(uuid) {
        return await this.httpGetRequest(`/admin/user/${uuid}/statistics`);
    },
    async getUsersMembership(uuid) {
        return await this.httpGetRequest(`/admin/user/${uuid}/membership`);
    },
    async httpGetRequest(path) {
        return await axios.get(path, {headers: getHeaders()}).then((res) => {
            if (res.status === 200) {
                return res.data;
            }
            else if (res.status === 401) {
                KeycloakService.logout();
            }
        }).catch((e) => {
            return {error: e, success: false};
        });
    },

    async httpPostRequest(path, body) {
        return await axios.post(path, body, {headers: getHeaders()}).then((res) => {
            if (res.status === 200) {
                return res.data;
            }
            else if (res.status === 401) {
                KeycloakService.logout();
            }
        }).catch((e) => {
            return {error: e, success: false};
        });
    }
}
